import React from 'react';
import { SpheraModal, SpheraSubTab, SpheraTab, SpheraDropdownEx } from '@sphera-cloud/component-ui-reactjs';
import { LoadingPanel } from '../LoadingPanel';
import { PhraseSection } from "../PhraseSection";
import { DocumentIngredients } from "../DocumentIngredients";
import { DocumentInfo } from "../DocumentInfo";
import { DocumentTransportation } from "../DocumentTransportation";
import { DocumentProperties } from "../DocumentProperties";

export function DocumentModal(props) {
    const [maximize, setmaximize] = React.useState(true);
    const [minimize, setminimize] = React.useState(false);
    const [height, setHeight] = React.useState("90%");
    const [width, setWidth] = React.useState(1000);

    const [showDd, setshowDd] = React.useState(false);
    const showHideClick = () => {
        setshowDd(!showDd);
    }

    let documentInfo = <DocumentInfo localizations={props.localizations} documentColumns={props.documentColumns} selectedDoc={props.selectedDoc} />;

    let ingredients = null;
    if (props.standardIngredients.length > 0 || props.fullIngredients.length > 0)
        ingredients = <DocumentIngredients localizations={props.localizations} standardDataResult={props.standardDataResult} standardDataState={props.standardDataState} standardDataStateChange={props.standardDataStateChange} fullDataResult={props.fullDataResult} fullDataState={props.fullDataState} fullDataStateChange={props.fullDataStateChange} />;

    let transportation = null;
    if (props.Transportation.length > 0)
        transportation = <DocumentTransportation localizations={props.localizations} transportationDataResult={props.transportationDataResult} transportationDataState={props.transportationDataState} transportationStateChange={props.transportationStateChange} />;

    let properties = <DocumentProperties localizations={props.localizations} selectedDoc={props.selectedDoc} />;

    return (
        <div>
            {props.showModal && (
                <SpheraModal className="documentModal" title={props.localizations.Document} width={width} height={height} onClose={props.toggle} noFooter={true}
                    useMaximizeButton={maximize}
                    useMinimizeButton={minimize}
                    onMaximize={() => {
                        setHeight(document.documentElement.clientHeight - 1);
                        setWidth(document.documentElement.clientWidth - 1);
                        setmaximize(false);
                        setminimize(true);
                    }}
                    onMinimize={() => {
                        setHeight("90%");
                        setWidth(1000);
                        setmaximize(true);
                        setminimize(false);
                    }}
                >
                    {props.pending && <LoadingPanel localizations={props.localizations} />}
                    <SpheraTab className="documentTabs">
                        <SpheraSubTab title={props.localizations.DocumentFile} className="documentTab" >
                            <iframe src={props.documentLink} title="modaliFrame" style={{ width: "100%", height: "calc(90vh - 160px)" }} ></iframe>
                        </SpheraSubTab>
                        <SpheraSubTab title={props.localizations.documentdetails} >
                            <label onClick={showHideClick} onKeyDown={(e) => { if (e.code === "Enter") showHideClick(); }} className="sphera-label-text" style={{ cursor: "pointer" }} >{props.localizations.ShowHideSections}<i style={{ verticalAlign: "middle" }} className={showDd ? 'icon-ui-general-caret-down' : 'icon-ui-general-caret-up'}></i></label>
                            {showDd && (<>
                                <SpheraDropdownEx wrap type="multi-select" onChange={props.handlePhrasesDropdownChange} options={props.sectionsDropdownData} width="100%" value={props.phraseSectionsSelected} />
                            </>)}
                            {props.sectionsTree.map((x, idx) => {
                                return <span key={idx + "phraseSection"} ><PhraseSection pictograms={props.pictograms} section={x} key={x.phraseSectionType.name} languageValue={props.languageValue} Ingredients={ingredients} DocumentInfo={documentInfo} properties={properties} Transportation={transportation} /></span>;
                            })}
                        </SpheraSubTab>
                    </SpheraTab>
                </SpheraModal>
            )}
        </div>
    );
}